/** Portrait phones and very narrow landscape (see styles/breakpoints.scss). */
export const COMPACT_MOBILE_MEDIA = '(max-width: 567.98px), (max-height: 500px) and (max-width: 567.98px)';

export const LANDSCAPE_SIDEBAR_MEDIA = '(orientation: landscape) and (min-width: 568px) and (max-width: 1023.98px)';

export const PHONE_LANDSCAPE_MEDIA = '(orientation: landscape) and (max-height: 500px) and (max-width: 932px)';
